import _ from 'lodash';

const stringInsensitiveCompare = (a, b) => {
    if (typeof a === 'string' && typeof b === 'string') {
        return _.toLower(a) === _.toLower(b);
    }
    return a === b;
};

/**
 * Check the requiredness of a ViewModelNode
 *
 * @param {object} currentVmNode
 * @param {object} question
 * @param {object} answers
 * @returns {object} - an object with the requiredness and visibility of the given ViewModelNode
 */
export default (currentVmNode, question, answers) => {
    return {
        visible: {
            get: () => {
                // Questions exist in meta-data that need to be filtered, as the answers are not available.
                // i.e. no answers are returned if the question is unavailable.
                if (answers[question.code] === undefined) {
                    return false;
                }

                return _.every(question.filters, (filter) => {
                    if (answers[filter.questionCode] !== undefined) {
                        return stringInsensitiveCompare(answers[filter.questionCode], filter.answer);
                        // return answers[filter.questionCode] === filter.answer;
                    }
                    return false;
                });
            },
        },
        required: {
            get: () => {
                return currentVmNode.aspects.visible && question.required;
            },
        },
    };
};
